<template>
  <el-collapse v-model="active" :accordion="true">
      <el-collapse-item title="Comments (optional)" name="comment">
        <el-input type="textarea" v-model="comment" :rows="4" placeholder="Write extra comments" :disabled="!answerExists">
        </el-input>
      </el-collapse-item>
    </el-collapse>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'CommentBox',
  data() {
    return {
      comment: null,
      active: ['comment']
    }
  },
  watch: {
    comment: function (newComment, oldComment) {
      this.debouncedSetComment()
    }
  },
  props: {
    questionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    answerExists() {
      const answers = this.$store.getters.answers
      const activeSector = this.$store.getters.activeSector

      if (answers && answers[activeSector.id] != null) {
        const index = answers[activeSector.id].findIndex(q => q.questionId === this.questionId)
        if (index > -1) {
          return true
        }
        return false
      }
      return false
    }
  },
  methods: {
    setComment() {
      const answers = this.$store.getters.answers
      const activeSector = this.$store.getters.activeSector

      if (answers && answers[activeSector.id] != null) {
        const index = answers[activeSector.id].findIndex(q => q.questionId === this.questionId)
        if (index > -1) {
          answers[activeSector.id][index].comment = this.comment
        }
      }
      this.$store.commit('setAnswers', answers)
    }
  },
  created() {
    this.debouncedSetComment = _.debounce(this.setComment, 500)
  }
}
</script>

<style lang="scss" scoped>
  .el-collapse-item__header {
      position: relative;
      padding-left: 20px;
    }
    .el-collapse-item__arrow {
      position: absolute;
      left: 0;
    }
</style>